<div class="container">
    <mat-card class="mat-elevation-z8 w-100">
        <div class="row card-border pt-2 pb-2">
            <div class="col-8">
                <h2>Formulário de cadastro</h2>
            </div>
        </div>
        <form class="row mt-2" [formGroup]="form">
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="name" [errorStateMatcher]="matcher">
                    <mat-error *ngIf="form.controls.name.invalid">
                        Nome é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>Descrição</mat-label>
                    <textarea matInput rows="3" cols="40" formControlName="desc"></textarea>
                    <mat-error *ngIf="form.controls.name.invalid">
                        Descrição é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>Fórmula SQL</mat-label>
                    <textarea matInput rows="5" cols="40" formControlName="sql"></textarea>
                    <mat-error *ngIf="form.controls.name.invalid">
                        Fórmula SQL é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6 text-left mt-3">
                <button mat-flat-button color="basic" (click)="back()" matTooltip="Voltar"
                    skipLocationChange>
                    <i class="fa fa-arrow-left fa-1x btnIcon"></i> Voltar
                </button>
            </div>
            <div class="col-6 text-right mt-3">
                <button mat-flat-button color="primary" (click)="saveAll()" matTooltip="Gravar Fórmula"
                    skipLocationChange>
                    <i class="fa fa-floppy-o fa-1x btnIcon"></i> Gravar Fórmula
                </button>
            </div>
        </form>
    </mat-card>
</div>